import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ colors, spacing }: Theme) => createStyles({
  root: {
    marginTop: spacing(1.5),
  },
  box: {
    '&:not(:first-child)': {
      marginTop: spacing(3),
    },
  },
  name: {
    color: colors.text.secondary,
  },
  value: {
    marginTop: spacing(1),
  },
});

export default styles;
